import type { SVGProps } from 'react';
const SvgTon = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.713 1.82H2.291c-.988 0-1.61.937-1.13 1.702l3.333 5.057c.226.32.762.32.988 0l3.333-5.057c.508-.765-.113-1.703-1.102-1.703m-3.19 5.23-.735-1.234-1.75-2.739c-.114-.172.027-.394.281-.394h2.203zm3.444-3.973-1.75 2.739-.735 1.233V2.683h2.203c.254 0 .395.222.282.394"
      fill="currentColor"
    />
  </svg>
);
export default SvgTon;
export { SvgTon };
